(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gel-social-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gel-social-reviews')) {
    customElements.define('gel-social-reviews', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const viewport = this.querySelector('.gel-reviews__viewport');
        const cards = [...this.querySelectorAll('.gel-reviews__card')];
        const dots = [...this.querySelectorAll('[data-review-index]')];
        const controls = this.querySelector('.gel-reviews__controls');
        if (!controls || cards.length < 2) return;
        const previous = this.querySelector('[data-review-step="-1"]');
        const next = this.querySelector('[data-review-step="1"]');
        let positions = [], stops = [], maxScroll = 0;
        const update = () => {
          const left = viewport.scrollLeft;
          const index = stops.reduce((best, i) => Math.abs(positions[i] - left) < Math.abs(positions[best] - left) ? i : best, stops[0]);
          dots.forEach((dot, i) => i === index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
          previous.disabled = left < 2;
          next.disabled = left >= maxScroll - 2;
        };
        const measure = () => {
          maxScroll = viewport.scrollWidth - viewport.clientWidth;
          const origin = cards[0].getBoundingClientRect().left;
          positions = cards.map(card => Math.min(maxScroll, card.getBoundingClientRect().left - origin));
          stops = positions.map((_, i) => i).filter(i => i === cards.length - 1 || positions[i + 1] - positions[i] > 2);
          dots.forEach((dot, i) => { dot.hidden = !stops.includes(i); });
          controls.hidden = maxScroll < 2;
          update();
        };
        const move = i => viewport.scrollTo({ left: positions[Math.max(0, Math.min(cards.length - 1, i))], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        this.addEventListener('click', event => {
          const dot = event.target.closest('[data-review-index]');
          const step = event.target.closest('[data-review-step]');
          if (dot) move(Number(dot.dataset.reviewIndex));
          if (step) {
            const direction = Number(step.dataset.reviewStep);
            const target = direction > 0 ? stops.find(i => positions[i] > viewport.scrollLeft + 2) : stops.findLast(i => positions[i] < viewport.scrollLeft - 2);
            move(target ?? 0);
          }
        }, options);
        viewport.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') move(0);
          else if (event.key === 'End') move(cards.length - 1);
          else (event.key === 'ArrowLeft' ? previous : next).click();
        }, options);
        viewport.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(update);
        }, { ...options, passive: true });
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.gel-reviews__card');
          if (card) move(cards.indexOf(card));
        }, options);
        this.resize = new ResizeObserver(measure);
        this.resize.observe(viewport);
        measure();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
